import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=887e5182&scoped=true&"
import script from "./ConfigForm.vue?vue&type=script&lang=js&"
export * from "./ConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfigForm.vue?vue&type=style&index=0&id=887e5182&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887e5182",
  null
  
)

export default component.exports